import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function SlideClose() {
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative overflow-hidden" data-id="element-75">
      {/* Background Glow */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none" data-id="element-76">
        <div className="w-[800px] h-[800px] bg-teal-400/5 rounded-full blur-[100px]" data-id="element-77" />
      </div>

      <div className="z-10 max-w-4xl w-full space-y-10" data-id="element-78">
        <div className="space-y-6" data-id="element-79">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-serif text-white" data-id="element-80">
            The Board Ask
          </motion.h2>

          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-3xl md:text-4xl font-serif text-teal-400" data-id="element-81">
            Approve Q1 Pilot Program
          </motion.h3>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="bg-navy-700/40 border border-navy-600 rounded-2xl px-8 py-8 max-w-2xl mx-auto text-left" data-id="element-82">
          <h4 className="text-white font-semibold text-xl mb-4 border-b border-navy-600 pb-4" data-id="element-83">
            Pilot Scope
          </h4>
          <ul className="space-y-4 text-lg text-white/80" data-id="element-84">
            <li className="flex items-start gap-3" data-id="element-85">
              <span className="text-teal-400 mt-1" data-id="element-86">→</span>
              <span data-id="element-87">
                <strong data-id="element-88">Allocation:</strong> [X] Budget
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-89">
              <span className="text-teal-400 mt-1" data-id="element-90">→</span>
              <span data-id="element-91">
                <strong data-id="element-92">Timeline:</strong> 12-week execution
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-93">
              <span className="text-teal-400 mt-1" data-id="element-94">→</span>
              <span data-id="element-95">
                <strong data-id="element-96">Coverage:</strong> 2 mature brands across 3-5 key
                markets
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-97">
              <span className="text-teal-400 mt-1" data-id="element-98">→</span>
              <span data-id="element-99">
                <strong data-id="element-100">Expected Outcome:</strong> Measurable improvement in
                legacy brand engagement and performance baseline.
              </span>
            </li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 1.1,
        type: 'spring'
      }} className="pt-6" data-id="element-101">
          <Button variant="primary" className="px-10 py-5 text-xl shadow-[0_0_30px_rgba(0,212,170,0.3)] hover:shadow-[0_0_50px_rgba(0,212,170,0.5)]" data-id="element-102">
            Approve Pilot
          </Button>
        </motion.div>
      </div>
    </div>;
}